import { NavigationStateShape } from 'store';

export default {
	navigationTree: Object(null),
	navigationData: Object(null),

	filter: ''
} as NavigationStateShape;
